// Contract for GET /risk/results/summary?configId= (I360A-2702).
// Keys are grade values '0'..'4' (0 Optimal … 4 Critical), matching
// GRADE_CONFIG. Lengths are metres; diameter keys are raw mm values.
export type GradeKey = '0' | '1' | '2' | '3' | '4';

export interface CountLength {
	count: number;
	length: number;
}

export type LabelBreakdown = Record<string, CountLength>;

export interface GradeBreakdown {
	material: LabelBreakdown;
	diameter: LabelBreakdown;
	year_laid: LabelBreakdown;
	assets_with_empty_length: number;
}

export interface RiskResultsSummary {
	totals: Record<GradeKey, CountLength>;
	/** In-scope assets with no risk row — not included in `totals`. */
	unscored: number;
	breakdown: Record<GradeKey, GradeBreakdown>;
}

export const UNKNOWN_LABEL = 'Unknown';

export interface ResultsSummaryState {
	status: 'idle' | 'loading' | 'loaded' | 'error';
	/** The config `data` belongs to — guards against showing another model's numbers. */
	configId?: string;
	data?: RiskResultsSummary;
	/** Set when a run completes in this session; `riskSetting.status` isn't
	 *  re-fetched on completion, so this is the in-session signal. */
	completedRunConfigId?: string;
	/** Bumped on every completed run so consumers can re-fetch. */
	completedRunCount: number;
}

export const resultsSummaryInitialState: ResultsSummaryState = {
	status: 'idle',
	completedRunCount: 0,
};
